import React, { Fragment } from "react";

import { RequestedDevicesInfo } from "../requestedDevicesInfo";
import {
  MobileSort,
  TableSearch,
} from "../../../../../../../components/table/components";
import { Mobile } from "../../../../../../../hocs/Responsive";

export const RequestedDevicesTableHeader = () => {
  return (
    <Fragment>
      <RequestedDevicesInfo />
      <TableSearch />

      <Mobile>
        <MobileSort />
      </Mobile>
    </Fragment>
  );
};
